const getStateSlice = (state) => state.threatStack;

// If adding selectors, keep the state as default and scale using named exports
export default getStateSlice;
